import { render, staticRenderFns } from "./medicalRecord.vue?vue&type=template&id=5bd144ea&scoped=true"
import script from "./medicalRecord.vue?vue&type=script&lang=js"
export * from "./medicalRecord.vue?vue&type=script&lang=js"
import style0 from "./medicalRecord.vue?vue&type=style&index=0&id=5bd144ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd144ea",
  null
  
)

export default component.exports